// extracted by mini-css-extract-plugin
export default {"none":"DetailsGridLayout_none__HQB1b","hidden":"DetailsGridLayout_hidden__OwGBs","fullDetails":"DetailsGridLayout_fullDetails__hc8Up"};